<template>
    <div>
        <cabecalho titulo="Fontes Sugeridas"/>
        <div class="container-fluid mb-4">
            <!--
            <ul class="list-group">
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/artigo-rlars-2019.pdf">
                ANÁLISE DE REDES NA PRODUÇÃO CIENTÍFICA DA PSICOLOGIA DO BRASIL: aspectos da internacionalização
                </a></li>
            </ul>
            <h4 class="mt-5 mb-3 text-center">Fontes Sugeridas</h4>
            -->
            <ul class="list-group">
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Acompanhamento de egresso.pdf">
                Acompanhamento de egresso
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Atuação profissional dos egressos.pdf">
                Atuação profissional dos egressos
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Bacharel e docencia.pdf">
                Bacharel e docencia
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/CAPES_Documento de Área MEDICINA_III_2016.pdf">
                CAPES Documento de Área MEDICINA III 2016
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/CNPQ_Grupos de Pesquisa Egressos 2010.pdf">
                CNPQ Grupos de Pesquisa Egressos 2010
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/CNPQ_Grupos de Pesquisa Egressos.pdf">
                CNPQ Grupos de Pesquisa Egressos
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Colaboração cientifica.pdf">
                Colaboração cientifica
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Construção da carreira egressos psicologia Tese.pdf">
                Construção da carreira egressos psicologia Tese
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Construção de conhecimento.pdf">
                Construção de conhecimento
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Curso Psicologia Sao Gabriel_Entradas e bandeiras.pdf">
                Curso Psicologia Sao Gabriel Entradas e bandeiras
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Egressos como avaliaçao Administração.pdf">
                Egressos como avaliaçao Administração
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Egressos Doutorado PSI_Lista.pdf">
                Egressos Doutorado PSI Lista
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Egressos Mestrado PSI_Lista.pdf">
                Egressos Mestrado PSI Lista
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Escritos sobre psicologo no Brasil Livro.pdf">
                Escritos sobre psicologo no Brasil Livro
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Formaçao de doutores.pdf">
                Formaçao de doutores
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Formaçao Psicologia_Demandas sociais.pdf">
                Formaçao Psicologia Demandas sociais
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Internacionalizaçao doutorado Psicologia BR e Spain.pdf">
                Internacionalizaçao doutorado Psicologia BR e Spain
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Lacunas de competencias egressos psicologia.pdf">
                Lacunas de competencias egressos psicologia
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Mestres_Doutores_2015_Vs3.pdf">
                Mestres Doutores 2015 Vs3
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Percepçao Egressos mestrado ciencias e saude.pdf">
                Percepçao Egressos mestrado ciencias e saude
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Perspectivas de egressos avaliação.pdf">
                Perspectivas de egressos avaliação
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Planejamento para acompanhamento egressos.pdf">
                Planejamento para acompanhamento egressos
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Produçao cientifica psicologia graduaçao.pdf">
                Produçao cientifica psicologia graduaçao
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Redes coautoria posgrado UFRGS.pdf">
                Redes coautoria posgrado UFRGS
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Sistema de Mapeamento de Egressos Proposta Medicina III.pdf">
                Sistema de Mapeamento de Egressos Proposta Medicina III
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Sistema de mapeamento de egressos.pdf">
                Sistema de mapeamento de egressos
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Teses e Dissetações Egressos 03-2017.pdf">
                Teses e Dissetações Egressos 03-2017
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Titulados Doutorado_Lista.pdf">
                Titulados Doutorado Lista
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Trajetoria de egressos.pdf">
                Trajetoria de egressos
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/Transnacionalização ensino psicologia.pdf">
                Transnacionalização ensino psicologia
                </a></li>
                <li class="list-group-item"><a target="blank" href="/AlumniPsiUFMG/artigos/EGRESSOS/UFMG_Grupo de Pesquisa Alumini.pdf">
                UFMG Grupo de Pesquisa Alumni
                </a></li>                
            </ul>
        </div>
    </div>    
</template>

<script>
import Cabecalho from '@/components/Cabecalho';
import BTable from 'bootstrap-vue/es/components/table/table'

export default {
    name: 'Downloads',
    components: {Cabecalho, BTable}    
}
</script>

<style>

</style>
